import React, { useEffect, useState } from 'react';
import { getEquipamentos, criarEquipamento, atualizarEquipamento, deletarEquipamento } from '../services/api';

const fabricantes = ['Queclink', 'Teltonika', 'Suntech', 'Coban', 'Concox', 'Sinotrack'];
const modelosPorFabricante = {
    Queclink: ['GV55', 'GV75', 'GV50CG', 'GV50', 'GV300', 'GV600'],
    Teltonika: ['FMB120', 'FMB140', 'FMB920', 'FMT100'],
    Suntech: ['ST300', 'ST600', 'ST400'],
    Coban: ['TK103', 'TK303', 'GPS303'],
    Concox: ['GT06', 'GT02', 'JM-LL01'],
    Sinotrack: ['ST-901', 'ST-906'],
};
const statusOpcoes = [
    { value: 'ativo', label: 'Ativo', cor: '#34c759' },
    { value: 'inativo', label: 'Inativo', cor: '#8e8e93' },
    { value: 'manutencao', label: 'Manutenção', cor: '#ff9500' },
];

function IosField({ label, children }) {
    return (
        <div style={{ borderBottom: '1px solid var(--ios-separator)' }}>
            <div style={{ padding: '0 16px' }}>
                <span style={{ fontSize: 11, color: 'var(--ios-gray)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', paddingTop: 9 }}>
                    {label}
                </span>
                {children}
            </div>
        </div>
    );
}

const inputStyle = {
    width: '100%', border: 'none', outline: 'none', fontSize: 15,
    fontFamily: 'var(--ios-font)', color: 'var(--ios-label)',
    background: 'transparent', padding: '8px 0 10px', boxSizing: 'border-box',
};

function ModalEquipamento({ equipamento, onSalvar, onFechar }) {
    const [form, setForm] = useState({
        imei: equipamento?.imei || '',
        fabricante: equipamento?.fabricante || 'Queclink',
        modelo: equipamento?.modelo || 'GV55',
        operadora: equipamento?.operadora || '',
        chip: equipamento?.chip || '',
        status: equipamento?.status || 'ativo',
    });
    const [erro, setErro] = useState('');
    const [salvando, setSalvando] = useState(false);

    const set = campo => e => setForm(f => ({ ...f, [campo]: e.target.value }));
    const setFabricante = e => {
        const fab = e.target.value;
        setForm(f => ({ ...f, fabricante: fab, modelo: (modelosPorFabricante[fab] || [])[0] || '' }));
    };

    const salvar = async () => {
        setErro(''); setSalvando(true);
        try {
            equipamento ? await atualizarEquipamento(equipamento.id, form) : await criarEquipamento(form);
            onSalvar();
        } catch(e) {
            setErro(e.response?.data?.erro || 'Erro ao salvar');
        } finally { setSalvando(false); }
    };

    const modelos = modelosPorFabricante[form.fabricante] || [];

    return (
        <div className="ios-overlay" onClick={onFechar}>
            <div className="ios-sheet" style={{ width: 400, maxWidth: '95vw' }} onClick={e => e.stopPropagation()}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid var(--ios-separator)' }}>
                    <button onClick={onFechar} style={{ background: 'none', border: 'none', color: '#ff3b30', fontSize: 15, cursor: 'pointer', fontFamily: 'var(--ios-font)' }}>Cancelar</button>
                    <span style={{ fontWeight: 600, fontSize: 16 }}>{equipamento ? 'Editar Equipamento' : 'Novo Equipamento'}</span>
                    <button onClick={salvar} disabled={salvando} style={{ background: 'none', border: 'none', color: '#007aff', fontSize: 15, fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--ios-font)' }}>
                        {salvando ? '...' : 'Salvar'}
                    </button>
                </div>

                <div style={{ padding: '20px 16px', background: 'var(--ios-gray6)', overflowY: 'auto', maxHeight: '70vh' }}>
                    <p style={{ fontSize: 12, color: 'var(--ios-gray)', textTransform: 'uppercase', letterSpacing: 0.5, margin: '0 4px 6px', fontWeight: 500 }}>Identificação</p>
                    <div className="ios-group" style={{ marginBottom: 16 }}>
                        <IosField label="IMEI">
                            <input style={inputStyle} placeholder="15 dígitos" value={form.imei} onChange={set('imei')} maxLength={15} inputMode="numeric" />
                        </IosField>
                        <div style={{ borderBottom: '1px solid var(--ios-separator)' }}>
                            <div style={{ padding: '0 16px' }}>
                                <span style={{ fontSize: 11, color: 'var(--ios-gray)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', paddingTop: 9 }}>Fabricante</span>
                                <select style={{ ...inputStyle, appearance: 'none' }} value={form.fabricante} onChange={setFabricante}>
                                    {fabricantes.map(f => <option key={f} value={f}>{f}</option>)}
                                </select>
                            </div>
                        </div>
                        <div style={{ borderBottom: '1px solid var(--ios-separator)' }}>
                            <div style={{ padding: '0 16px' }}>
                                <span style={{ fontSize: 11, color: 'var(--ios-gray)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', paddingTop: 9 }}>Modelo</span>
                                <select style={{ ...inputStyle, appearance: 'none' }} value={form.modelo} onChange={set('modelo')}>
                                    {modelos.map(m => <option key={m} value={m}>{m}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>

                    <p style={{ fontSize: 12, color: 'var(--ios-gray)', textTransform: 'uppercase', letterSpacing: 0.5, margin: '0 4px 6px', fontWeight: 500 }}>Chip / Operadora</p>
                    <div className="ios-group" style={{ marginBottom: 16 }}>
                        <IosField label="Número do chip">
                            <input style={inputStyle} placeholder="Ex: (11) 99999-0000" value={form.chip} onChange={set('chip')} />
                        </IosField>
                        <IosField label="Operadora">
                            <input style={inputStyle} placeholder="Ex: Claro, Vivo, TIM..." value={form.operadora} onChange={set('operadora')} />
                        </IosField>
                    </div>

                    <p style={{ fontSize: 12, color: 'var(--ios-gray)', textTransform: 'uppercase', letterSpacing: 0.5, margin: '0 4px 6px', fontWeight: 500 }}>Status</p>
                    <div className="ios-group" style={{ marginBottom: 16 }}>
                        {statusOpcoes.map((s, i) => (
                            <div key={s.value} onClick={() => setForm(f => ({ ...f, status: s.value }))}
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '13px 16px', cursor: 'pointer', background: 'white', borderBottom: i < statusOpcoes.length - 1 ? '1px solid var(--ios-separator)' : 'none' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <div style={{ width: 8, height: 8, borderRadius: '50%', background: s.cor }} />
                                    <span style={{ fontSize: 15, color: 'var(--ios-label)' }}>{s.label}</span>
                                </div>
                                {form.status === s.value && (
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                        <path d="M20 6L9 17l-5-5" stroke="#007aff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                )}
                            </div>
                        ))}
                    </div>

                    {erro && <div style={{ background: 'rgba(255,59,48,0.08)', borderRadius: 10, padding: '10px 14px', color: '#ff3b30', fontSize: 13 }}>{erro}</div>}
                </div>
            </div>
        </div>
    );
}

export default function Equipamentos({ onFechar }) {
    const [equipamentos, setEquipamentos] = useState([]);
    const [editando, setEditando] = useState(null);
    const [novo, setNovo] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(null);
    const [filtroStatus, setFiltroStatus] = useState('todos');

    const carregar = async () => {
        const res = await getEquipamentos();
        setEquipamentos(res.data);
    };

    useEffect(() => { carregar(); }, []);

    const excluir = async (id) => {
        try {
            await deletarEquipamento(id);
            setConfirmDelete(null);
            carregar();
        } catch(e) {
            alert(e.response?.data?.erro || 'Erro ao excluir');
            setConfirmDelete(null);
        }
    };

    const filtrados = filtroStatus === 'todos' ? equipamentos : equipamentos.filter(e => e.status === filtroStatus);

    const corStatus = s => statusOpcoes.find(o => o.value === s)?.cor || '#8e8e93';
    const labelStatus = s => statusOpcoes.find(o => o.value === s)?.label || s;

    const contagem = {
        ativo: equipamentos.filter(e => e.status === 'ativo').length,
        inativo: equipamentos.filter(e => e.status === 'inativo').length,
        manutencao: equipamentos.filter(e => e.status === 'manutencao').length,
    };

    return (
        <div className="ios-overlay" onClick={onFechar}>
            <div className="ios-sheet" style={{ width: 680, maxWidth: '96vw', maxHeight: '88vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid var(--ios-separator)', flexShrink: 0 }}>
                    <span style={{ fontWeight: 600, fontSize: 17 }}>Equipamentos</span>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <button className="ios-btn ios-btn-primary ios-btn-sm" onClick={() => setNovo(true)}>+ Novo</button>
                        <button className="ios-btn ios-btn-gray ios-btn-sm" onClick={onFechar}>Fechar</button>
                    </div>
                </div>

                {/* Cards de contagem */}
                <div style={{ display: 'flex', gap: 8, padding: '12px 16px', borderBottom: '1px solid var(--ios-separator)', flexShrink: 0 }}>
                    {[
                        { key: 'todos', label: 'Todos', valor: equipamentos.length, cor: '#007aff' },
                        { key: 'ativo', label: 'Ativos', valor: contagem.ativo, cor: '#34c759' },
                        { key: 'inativo', label: 'Inativos', valor: contagem.inativo, cor: '#8e8e93' },
                        { key: 'manutencao', label: 'Manutenção', valor: contagem.manutencao, cor: '#ff9500' },
                    ].map(c => (
                        <div key={c.key} onClick={() => setFiltroStatus(c.key)} style={{
                            flex: 1, background: filtroStatus === c.key ? c.cor : 'white',
                            borderRadius: 10, padding: '8px 10px', textAlign: 'center',
                            cursor: 'pointer', transition: 'all 0.15s',
                            boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                            border: filtroStatus === c.key ? 'none' : '1px solid var(--ios-separator)',
                        }}>
                            <div style={{ fontSize: 18, fontWeight: 700, color: filtroStatus === c.key ? 'white' : c.cor }}>{c.valor}</div>
                            <div style={{ fontSize: 10, color: filtroStatus === c.key ? 'rgba(255,255,255,0.85)' : '#8e8e93', marginTop: 1, fontWeight: 500 }}>{c.label}</div>
                        </div>
                    ))}
                </div>

                {/* Lista */}
                <div style={{ overflowY: 'auto', flex: 1, padding: 16 }}>
                    {filtrados.length === 0 ? (
                        <div style={{ textAlign: 'center', color: 'var(--ios-gray)', padding: 40, fontSize: 15 }}>Nenhum equipamento</div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 1, borderRadius: 12, overflow: 'hidden', boxShadow: 'var(--ios-shadow)' }}>
                            {filtrados.map((e, i) => (
                                <div key={e.id} style={{
                                    background: 'white', padding: '12px 16px',
                                    display: 'flex', alignItems: 'center', gap: 12,
                                    borderBottom: i < filtrados.length - 1 ? '1px solid var(--ios-separator)' : 'none',
                                }}>
                                    {/* Ícone */}
                                    <div style={{
                                        width: 38, height: 38, borderRadius: 10, flexShrink: 0,
                                        background: 'rgba(0,122,255,0.1)',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    }}>
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#007aff" strokeWidth="2" strokeLinecap="round">
                                            <rect x="5" y="2" width="14" height="20" rx="2"/>
                                            <line x1="12" y1="18" x2="12" y2="18.01"/>
                                        </svg>
                                    </div>

                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <span style={{ fontWeight: 600, fontSize: 14, color: 'var(--ios-label)' }}>{e.fabricante} {e.modelo}</span>
                                            <span style={{
                                                fontSize: 10, fontWeight: 600, borderRadius: 20, padding: '2px 7px',
                                                background: corStatus(e.status) + '20', color: corStatus(e.status),
                                            }}>{labelStatus(e.status)}</span>
                                        </div>
                                        <div style={{ fontSize: 12, color: '#8e8e93', marginTop: 2, fontFamily: 'monospace' }}>{e.imei}</div>
                                        <div style={{ fontSize: 11, color: '#aeaeb2', marginTop: 2 }}>
                                            {[e.operadora, e.chip].filter(Boolean).join(' · ')}
                                            {(e.veiculo_principal || e.veiculo_redundante) && (
                                                <span style={{ color: '#007aff', marginLeft: 6 }}>
                                                    📍 {e.veiculo_principal || e.veiculo_redundante}
                                                    {e.veiculo_principal && e.veiculo_redundante ? ' (2 veículos)' : ''}
                                                </span>
                                            )}
                                            {!e.veiculo_principal && !e.veiculo_redundante && (
                                                <span style={{ color: '#34c759', marginLeft: 6 }}>livre</span>
                                            )}
                                        </div>
                                    </div>

                                    <button className="ios-btn ios-btn-gray ios-btn-sm" onClick={() => setEditando(e)}>Editar</button>
                                    <button className="ios-btn ios-btn-sm" style={{ background: 'rgba(255,59,48,0.1)', color: '#ff3b30' }} onClick={() => setConfirmDelete(e)}>Excluir</button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {(novo || editando) && (
                <ModalEquipamento
                    equipamento={editando}
                    onSalvar={() => { setNovo(false); setEditando(null); carregar(); }}
                    onFechar={() => { setNovo(false); setEditando(null); }}
                />
            )}

            {confirmDelete && (
                <div className="ios-overlay">
                    <div className="ios-sheet" style={{ width: 300, overflow: 'hidden' }} onClick={e => e.stopPropagation()}>
                        <div style={{ padding: '24px 20px 8px', textAlign: 'center' }}>
                            <div style={{ fontWeight: 600, fontSize: 17, marginBottom: 6 }}>Excluir Equipamento</div>
                            <div style={{ fontSize: 14, color: 'var(--ios-gray)', marginBottom: 20 }}>
                                IMEI <strong>{confirmDelete.imei}</strong> será removido.
                            </div>
                        </div>
                        <div style={{ borderTop: '1px solid var(--ios-separator)', display: 'flex' }}>
                            <button onClick={() => setConfirmDelete(null)} style={{ flex: 1, padding: 14, border: 'none', borderRight: '1px solid var(--ios-separator)', background: 'white', fontSize: 16, color: '#007aff', cursor: 'pointer', fontFamily: 'var(--ios-font)' }}>Cancelar</button>
                            <button onClick={() => excluir(confirmDelete.id)} style={{ flex: 1, padding: 14, border: 'none', background: 'white', fontSize: 16, color: '#ff3b30', fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--ios-font)' }}>Excluir</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
